import { render, staticRenderFns } from "./latestjobdashboard.vue?vue&type=template&id=8b7a6010"
import script from "./latestjobdashboard.vue?vue&type=script&lang=js"
export * from "./latestjobdashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports